import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ActivityLocationService } from '@app/modules/activity-location/services/activity-location.service';
import { catchError, map, tap } from 'rxjs/operators';
import * as ActivityLocationApiActions from '@app/modules/activity-location/actions/activity-location-api.actions';
import { Store } from '@ngrx/store';
import { State } from '@app/reducers';

export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const activityLocationService = inject(ActivityLocationService);
    const router = inject(Router);
    const store = inject(Store<State>);

    return activityLocationService.get(route.params['id']).pipe(
        map(activityLocation => ActivityLocationApiActions.GetSuccess(activityLocation)),
        tap((action: any) => store.dispatch(action)),
        map(activityLocation => !!activityLocation),
        catchError(() => {
            return router.navigate(['/not-found']);
        })
    );
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);